// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.style-slide-img[data-v-d7a348a4] {\n  max-height: 140px;\n  max-width: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n", ""]);
// Exports
module.exports = exports;
